function timeCurrent() {
  return new Date().getTime()
}

export { timeCurrent }
